import { c as _c } from "react/compiler-runtime";
import { cn } from "@matsuricon/ui/utils";
import Image from "next/image";
type SiteWordmarkProps = {
  className?: string;
  compact?: boolean;
};
export function SiteWordmark(t0) {
  const $ = _c(8);
  const {
    className,
    compact: t1
  } = t0;
  const compact = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("inline-flex min-w-0 items-center gap-2 font-sans font-bold tracking-normal", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Image src="/kanji-logo-2027.png" alt="" width={36} height={36} className="size-9 shrink-0 object-contain" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== compact) {
    t4 = compact ? null : <span className="truncate text-sm text-foreground">MATSURICON</span>;
    $[3] = compact;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2 || $[6] !== t4) {
    t5 = <span aria-hidden="true" className={t2} translate="no">{t3}{t4}</span>;
    $[5] = t2;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}